import React, { useContext, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import AuthContext from '../../contexts/auth';
import SidebarContext from '../../contexts/sidebar';
import Options from '../Sidebar/Options/indexRoles';
import { translate } from '../../utils/Common';
import styles from './SubmenuModal.module.css';

const SubmenuModal = ({ isOpen, onClose, type = "packages" }) => {
    const userContext = useContext(AuthContext);
    const sidebarContext = useContext(SidebarContext);
    const history = useHistory();
    const modalRef = useRef(null);

    // Obtener las opciones del sidebar
    const sidebarOptions = Options(userContext.user) || [];
    
    let selectedOption = null;
    let modalTitle = '';
    
    if (type === "packages") {
        modalTitle = translate('sidebar.options.packages');
        selectedOption = sidebarOptions.find(option => {
            if (!option) return false;
            const isPackagesPath = option.path === '/dashboard/packages/' || option.path === '/dashboard/packages';
            const isPackagesTitle = option.title === translate('sidebar.options.packages');
            return isPackagesPath || isPackagesTitle;
        });
    } else if (type === "platforms") {
        modalTitle = translate('sidebar.options.platforms');
        selectedOption = sidebarOptions.find(option => {
            if (!option) return false;
            const isPlatformsPath = option.path === '/dashboard/platforms/' || option.path === '/dashboard/platforms';
            const isPlatformsTitle = option.title === translate('sidebar.options.platforms');
            return isPlatformsPath || isPlatformsTitle;
        });
    }

    const submenuItems = selectedOption?.subNav || [];
    
    // Debug: verificar que se encuentren las opciones
    useEffect(() => {
        if (isOpen) {
            console.log('SubmenuModal - type:', type);
            console.log('SubmenuModal - sidebarOptions:', sidebarOptions);
            console.log('SubmenuModal - selectedOption:', selectedOption);
            console.log('SubmenuModal - submenuItems:', submenuItems);
        }
    }, [isOpen, type, sidebarOptions, selectedOption, submenuItems]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.body.style.overflow = '';
        };
    }, [isOpen, onClose]);

    const handleItemClick = (item) => {
        history.push(item.path);
        sidebarContext.handleChangeCurrentPage(item.title);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div 
                ref={modalRef}
                className={styles.modal}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.modalHeader}>
                    <div className={styles.modalTitleContainer}>
                        {selectedOption?.icon && (
                            <span className={styles.modalIcon}>{selectedOption.icon}</span>
                        )}
                        <h3 className={styles.modalTitle}>{modalTitle}</h3>
                    </div>
                    <button 
                        className={styles.closeButton}
                        onClick={onClose}
                        aria-label={translate('global.close')}
                    >
                        ×
                    </button>
                </div>
                
                <div className={styles.modalContent}>
                    {submenuItems.length > 0 ? (
                        <ul className={styles.submenuList}>
                            {submenuItems.map((item, index) => (
                                <li key={index}>
                                    <button
                                        className={styles.submenuItem}
                                        onClick={() => handleItemClick(item)}
                                    >
                                        {item.icon && (
                                            <span className={styles.submenuItemIcon}>{item.icon}</span>
                                        )}
                                        <span className={styles.submenuItemText}>{item.title}</span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <div className={styles.emptyState}>
                            <p>{translate('sidebar.menu.noOptions')}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SubmenuModal;

